/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JackpotFormats
 */
export interface JackpotFormats {
    /**
     * 
     * @type {string}
     * @memberof JackpotFormats
     */
    formatC?: string;
    /**
     * 
     * @type {string}
     * @memberof JackpotFormats
     */
    formatB?: string;
    /**
     * 
     * @type {string}
     * @memberof JackpotFormats
     */
    formatA: string;
}

/**
 * Check if a given object implements the JackpotFormats interface.
 */
export function instanceOfJackpotFormats(value: object): value is JackpotFormats {
    if (!('formatA' in value) || value['formatA'] === undefined) return false;
    return true;
}

export function JackpotFormatsFromJSON(json: any): JackpotFormats {
    return JackpotFormatsFromJSONTyped(json, false);
}

export function JackpotFormatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): JackpotFormats {
    if (json == null) {
        return json;
    }
    return {
        
        'formatC': json['formatC'] == null ? undefined : json['formatC'],
        'formatB': json['formatB'] == null ? undefined : json['formatB'],
        'formatA': json['formatA'],
    };
}

export function JackpotFormatsToJSON(value?: JackpotFormats | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'formatC': value['formatC'],
        'formatB': value['formatB'],
        'formatA': value['formatA'],
    };
}

